// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"691c848f","455":"a473b449","977":"afde83b6"}[chunkId] + ".chunk.js";
};